
import { Link } from 'react-router-dom';
import { venuesListData } from '../../mocks/venuesList';
import VenuesListHeader from './components/VenuesListHeader';
import VenuesListFooter from './components/VenuesListFooter';
import VenueListCard from './components/VenueListCard';

export default function VenuesListPage() {
  return (
    <div className="min-h-screen bg-white">
      <VenuesListHeader />

      <main className="pt-20">
        {/* Hero / Introduction */}
        <section className="relative py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex items-center gap-2 text-sm text-gray-500 mb-6">
              <Link to="/" className="hover:text-gray-900 transition-colors cursor-pointer">トップページ</Link>
              <i className="ri-arrow-right-s-line text-gray-400"></i>
              <span className="text-gray-900 font-medium">参加会場一覧</span>
            </div>

            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              <a href="#venues-list-section" className="hover:opacity-80 transition-opacity">参加会場一覧</a>
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl leading-relaxed mb-6">
              本ページは日本音楽会場協会 東京支部に参加しているライブハウスの一覧ページです。各会場の公式サイトやSNSへのリンクを掲載しています。会場の公式ページで最新のスケジュール・チケット情報をご確認のうえご来場ください。
            </p>

            <div className="bg-white border border-gray-200 rounded-lg p-6 max-w-3xl">
              <h2 className="text-base font-bold text-gray-900 mb-3 flex items-center gap-2">
                <i className="ri-information-line text-gray-600"></i>
                ご注意
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed mb-3">
                本ページの掲載は各会場からの情報提供を基にしています。住所・アクセス等は公式サイトで必ずご確認ください。
              </p>
              <p className="text-sm text-gray-600 leading-relaxed">
                なお、サイト制作や表示内容の修正依頼は「支部窓口」より承ります（支部窓口フォーム／提案準備窓口をご利用ください）。
              </p>
            </div>
          </div>
        </section>

        {/* Venues List */}
        <section id="venues-list-section" className="py-16">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex items-center justify-between mb-8">
              <p className="text-sm text-gray-500">
                掲載会場数：<strong className="text-gray-900">{venuesListData.length}</strong> 件
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {venuesListData.map((venue, index) => (
                <VenueListCard key={index} venue={venue} />
              ))}
            </div>
          </div>
        </section>

        {/* Template Guide */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-3xl mx-auto px-6">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 text-center">会場掲載をご希望の方へ</h2>
            <p className="text-gray-600 mb-8 leading-relaxed text-center">
              当ページへの情報掲載・修正依頼は下記の支部窓口よりお申し込みください。掲載前に会場の許諾を必ず取得してください。
            </p>

            <div className="bg-white border border-gray-200 rounded-lg p-6 mb-8">
              <h3 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
                <i className="ri-file-text-line text-gray-500"></i>
                会場掲載用テンプレート
              </h3>
              <div className="bg-gray-50 rounded-md p-4 text-sm text-gray-600 leading-relaxed font-mono">
                <p>会場名：</p>
                <p>収容：</p>
                <p>アクセス：</p>
                <p>備考：</p>
                <p>公式サイト・予約 → （URLを貼る）</p>
              </div>
              <p className="text-xs text-gray-400 mt-3">上記フォーマットで会場情報をご記入のうえ、支部窓口までお送りください。</p>
            </div>

            <div className="text-center">
              <a
                href="/#contact"
                className="inline-flex items-center gap-2 bg-gray-900 text-white px-8 py-3 rounded-md text-sm font-semibold hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-send-line"></i>
                支部窓口へお問い合わせ
              </a>
            </div>
          </div>
        </section>
      </main>

      <VenuesListFooter />
    </div>
  );
}
